







































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import {CFMDTORoomType } from '@/scripts/services/ClientApiAuto'

@Component<RoomTypeDialog>({
    validations() {
        return {
          roomType:{
              Name: {required}
          }
        }
    },
})
export default class RoomTypeDialog extends CFMDialog {
    roomType: CFMDTORoomType = {Name: ''};

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.roomType.roomTypeGetById({id: <number>this.id});
        console.log(res);
        this.roomType = res.data;
      }
      blockui.unBlockModal();
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.roomType.Id,
        Name: this.roomType.Name,
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.roomType.roomTypeSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
